/**
 * Recharts styling constants, derived from the design tokens defined in
 * src/styles/global.css. No chart component may hardcode a color outside
 * these exports — keeps every chart visually consistent with the rest of
 * the design system and lets the palette shift in one place.
 *
 * Recharts props (stroke/fill) require literal color values, not CSS
 * custom property references resolved at paint time the way DOM elements
 * can use var(...) directly — so these are the same hex values as
 * global.css's token definitions, kept in sync manually. If global.css's
 * --positive-500/--negative-500/--brand-500/--premium-500 values change,
 * update here too.
 */

export const chartColors = {
  positive: "#3ddc97",
  negative: "#f2667a",
  brand: "#2dd4bf",
  premium: "#e8b454",
  neutralLine: "#6b7686",
  gridLine: "#232c3a",
  tooltipBg: "#182030",
  tooltipBorder: "#324154",
  textMuted: "#9aa7b8",
} as const;

export const chartFontFamily =
  '"IBM Plex Mono", "JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace';

/** Shared tooltip content style, used by every chart that renders a recharts <Tooltip>. */
export const tooltipContentStyle = {
  background: chartColors.tooltipBg,
  border: `1px solid ${chartColors.tooltipBorder}`,
  borderRadius: 8,
  fontSize: 12,
  fontFamily: chartFontFamily,
  color: "#e7ecf3",
} as const;

export const tooltipLabelStyle = {
  color: chartColors.textMuted,
  marginBottom: 4,
} as const;
